import React, { useEffect } from 'react';

import Aboutawardscelebrations from './Aboutawardscelebrations'
import AboutAwardsbanner from './AboutAwardsbanner';
import Aboutusawardsection from './Aboutusawardsection';
import Awardsanimatedcards from './Awardsanimatedcards';
import Awardssectioncard from './Awardssectioncard';
const Aboutawards = () => {
          useEffect(() => {
            window.scrollTo(0, 0);
          }, []); // Empty dependency array ensures it only runs once when the component mounts
                  // Scroll to the top of the page when the component mounts
         
    return (
        <div style={{ backgroundColor: '#fff' }}>
            {/* <AboutPartnersbanner /> */}
            {/* <AboutqualityBanner /> */}
            <AboutAwardsbanner />
            <Aboutawardscelebrations />
            <Awardssectioncard />
            <Awardsanimatedcards />
            
            {/* <Aboutusawardsection /> */}
            {/* <Aboutpatnersectionfirst /> */}
            {/* <Aboutqualitysection /> */}
            {/* <Aboutwithparthers /> */}
            {/* <Aboutusobjectives />
            <AboutQualityCards />
            <AboutqualityCertificatecards /> */}
        </div>
    );
};

export default Aboutawards;
